/* eslint-disable max-len */
const React = require('react');

const OverViewPlugins = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <path fill="#FFF" stroke="#009EE3" strokeWidth="1.364" d="M.909 6.25h17.557c.502 0 .909.407.909.909v8.779c0 5.35-4.337 9.687-9.688 9.687-5.35 0-9.687-4.337-9.687-9.688V7.16c0-.502.407-.909.909-.909z" transform="translate(-874 -1209) translate(874 1209) translate(7.5 7.5)" />
            <path fill="#009EE3" fillRule="nonzero" d="M11.25 4.375L17.5 4.375 17.5 3.125 11.25 3.125z" transform="translate(-874 -1209) translate(874 1209) translate(7.5 7.5) rotate(90 14.375 3.75)" />
            <path fill="#009EE3" fillRule="nonzero" d="M0.625 10.625L19.375 10.625 19.375 9.375 0.625 9.375z" transform="translate(-874 -1209) translate(874 1209) translate(7.5 7.5) rotate(-180 10 10)" />
            <g fill="#009EE3" fillRule="nonzero">
              <g>
                <path d="M0 8.125l.768-1.061c.543.578 1.394 1.085 2.493 1.085 1.134 0 1.583-.555 1.583-1.074 0-.707-.839-.92-1.796-1.167C1.76 5.59.248 5.212.248 3.55c0-1.298 1.146-2.3 2.871-2.3 1.229 0 2.221.39 2.954 1.097L5.28 3.373c-.614-.614-1.453-.897-2.28-.897-.815 0-1.335.39-1.335.98 0 .612.803.813 1.737 1.049 1.3.33 2.847.73 2.847 2.44 0 1.31-.922 2.43-3.048 2.43-1.453 0-2.505-.507-3.202-1.25z" transform="translate(-874 -1209) translate(874 1209) translate(7.5 7.5) translate(6.25 11.875) translate(.313)" />
                <path d="M3.75 1.875L3.75 0 2.5 0 2.5 1.875zM3.75 10.625L3.75 8.75 2.5 8.75 2.5 10.625z" transform="translate(-874 -1209) translate(874 1209) translate(7.5 7.5) translate(6.25 11.875) translate(.313)" />
              </g>
            </g>
            <path fill="#009EE3" fillRule="nonzero" d="M1.875 4.375L8.125 4.375 8.125 3.125 1.875 3.125z" transform="translate(-874 -1209) translate(874 1209) translate(7.5 7.5) rotate(90 5 3.75)" />
            <path stroke="#009EE3" strokeWidth="1.25" d="M10 25.625v1.25c0 2.416 1.959 4.375 4.375 4.375h11.25" transform="translate(-874 -1209) translate(874 1209) translate(7.5 7.5)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

module.exports = OverViewPlugins;
